export default
{
    computed:
    {
        //TODO BRAT DO UVAHY TIMEPICKER

        hours()
        {
            let values = []; let max = this.hour24? 24:12;

            for( let i=0; i< max; i++ )
            {
                values.push(this.hour24? i:i+1);
            }

            return values;
        },

        //TODO BRAT DO UVAHY TIMEPICKER

        minutes()
        {
            let values = []; let max = 60;

            for( let i=0; i< max; i=i+this.miniuteIncrement )
            {
                values.push(i);
            }

            return values;
        }
    }
}